import { consoleLogger } from '@proc7ts/logger';
import { RequestCapability } from '../request-capability.js';
import { requestExtension } from '../request-modification.js';
/**
 * @internal
 */
class LoggingCapability extends RequestCapability {
    for;
    constructor(log, byDefault = false) {
        super();
        if (byDefault) {
            this.for =
                (handler) => context => {
                    if (context.log) {
                        return context.next(handler);
                    }
                    return context.next(handler, requestExtension({ log }));
                };
        }
        else {
            this.for =
                (handler) => context => context.next(handler, requestExtension({ log }));
        }
    }
    logBy(log) {
        return new LoggingCapability(log);
    }
}
/**
 * Request logging capability instance.
 *
 * Uses a global `console` as {@link LoggerMeans.log request logger}, unless the logger is present in request context
 * already.
 */
export const Logging = /*#__PURE__*/ new LoggingCapability(consoleLogger, true);
//# sourceMappingURL=logging.capability.js.map